import { render, staticRenderFns } from "./tutors.vue?vue&type=template&id=3b42d336"
import script from "./tutors.vue?vue&type=script&lang=js"
export * from "./tutors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports